import { defineStore } from "pinia";
import { ref } from "vue";

export const useAccessRenewalOfferModalStore = defineStore(
	"accessRenewalOfferModal",
	() => {
		const isOpen = ref(false);

		const open = () => {
			isOpen.value = true;
		};

		const close = () => {
			isOpen.value = false;
		};

		return {
			isOpen,
			open,
			close,
		};
	}
);
